import { BOGeneralValues } from "./BOGeneralValues.model";

export class BORemission extends BOGeneralValues{
  id:number;
  remissionDay?:Date | undefined;
  epsId?:number;
  clinicHistoryId:number;
  patientName:string;
  birthDay?:Date | undefined;
  patientDocumentType:number;
  patientDocumentId:string;
  age:number;
  babyMonths?:string;
  genderIdentityId:number;
  address?:string;
  cellPhoneNumber:string;
  responsibleForPatient?: string;
  relativeType?:string;
  responsibleCellPhoneNumber?:string;
  receptorOrganization?:string;
  receptorOrganizationService?:string;
  receptorOrganizationPhone?:string;
  receptorOrganizationAddress?:string;

  receptorPersonAuthorizer?:string;
  receptorPersonAuthorizerPosition?:string;
  //cie11Diagnostic:string;
 // cie10Diagnostic:string;
  cie10CodeCtrl?:string;
  cie10DiseaseNameCtrl?:string;
  cie11CodeCtrl?:string;
  cie11DiseaseNameCtrl?:string;

  basicReasonRemission:string;
  clinicHistorySummary?:string;
  observations?:string;
  referringPhysician:string
  registerNumber?:string | undefined;
  rethus?:string | undefined;
}
